import styled from 'styled-components'

export const Box = styled.div`
  width: 218px;
  height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.grey[400]};
  border-radius: 4px;
  margin-top: 8px;
  padding-right: 8px;
`

export const RadioContainer = styled.div`
  margin: 0 8px 0 16px;
`

export const ZipcodeDetail = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ZipcodeRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const MainAddressBox = styled.div`
  width: 80px;
  height: 12px;
  background-color: rgba(102, 169, 255, 0.1);
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ZipcodeText = styled.div`
  font-size: 0.625rem;
  font-weight: 500;
  line-height: 10px;
  color: ${(props) => props.theme.colors.grey[300]};
`

export const MainAddressText = styled.div`
  font-size: 0.5625rem;
  font-weight: 500;
  line-height: 10px;
  color: ${(props) => props.theme.primary.main};
  text-align: center;
`

export const AddressText = styled.div`
  margin-top: 2px;
  font-size: 0.5rem;
  font-weight: 400;
  line-height: 10px;
  color: ${(props) => props.theme.colors.grey[300]};
`
